import { cn } from "@/lib/utils";

export type CompanyKpi = {
  label: string;
  value: string;
  caption: string;
  /** Clase de color del número: cada indicador tiene el suyo en todo Empresas. */
  valueClass: string;
};

/** La fila de indicadores arriba de los resultados de Empresas. */
export function CompanyKpis({ kpis }: { kpis: CompanyKpi[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
      {kpis.map((kpi) => (
        <div key={kpi.label} className="min-w-0 rounded-2xl bg-card p-4 shadow-sm lg:p-5">
          <div className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
            {kpi.label}
          </div>
          <div
            className={cn(
              "mt-1 truncate text-2xl font-extrabold tabular-nums lg:text-3xl",
              kpi.valueClass,
            )}
          >
            {kpi.value}
          </div>
          <div className="mt-0.5 truncate text-xs text-muted-foreground" title={kpi.caption}>
            {kpi.caption}
          </div>
        </div>
      ))}
    </div>
  );
}
